import { HTTPMethod, request } from '../../global/api/legacyApi'
import { type APIResponse } from '../../sharedLegacy/utils/api.types'
import { type AudienceMemberDTO } from '../model/Audience'

type AudienceOrderBy =
  | 'profile_count'
  | 'recent'
  | 'timeline_count'
  | 'score'
  | 'first'

type AudienceIdentityObjects = number[]

type GetAudienceListOptions = {
  uuid?: string
  orderBy?: AudienceOrderBy
  timelineObjects?: number[]
  objects?: number[]
  identified?: number
  order?: 'asc' | 'desc'
  identityObjects?: AudienceIdentityObjects
  includeTimelines?: boolean
  includeEvents?: boolean
  size?: number
  p?: number
}

const getAudienceList = ({
  includeEvents,
  includeTimelines,
  objects,
  timelineObjects,
  order,
  orderBy,
  size,
  p,
}: GetAudienceListOptions) => {
  return request<APIResponse<AudienceMemberDTO[]>>({
    url: '/api/2/audience/list',
    method: HTTPMethod.GET,
    data: {
      include_timelines_p: includeTimelines,
      include_events_p: includeEvents,
      timeline_objects: timelineObjects,
      objects,
      orderby: orderBy,
      order,
      size,
      p,
    },
  })
}

export { getAudienceList }
